import { debounce } from "lodash";
import React from "react";

const ProfileAnnexesFormGroup = ({
   option,
   type = { form: "textarea", row: 10 },
   register,
   handleRestore,
   submitAfterDebounce,
}) => {
   console.log("option", option);
   const renderReset = (item) => {
      return (
         <div className={"ml-1"}>
            <div
               className={"btn ue-btn-circle bg-primary"}
               data-toggle="tooltip"
               data-placement="top"
               title="Valeur par default"
               onClick={(e) => handleRestore(e, item)}
            >
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-counterclockwise"
                  viewBox="0 0 16 16"
               >
                  <path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
                  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
               </svg>
            </div>
         </div>
      );
   };

   return (
      <>
         <div className="d-flex flex-column w-100 p-1">
            <div className={"d-flex w-100 justify-content-between align-items-center mb-2 ue-modal-form-label"}>
               <label className={"font-weight-bold "} htmlFor={option.name}>
                  {option.title}
               </label>
               {renderReset(option.name)}
            </div>
            <div className="d-flex w-100">
               {type?.form === "textarea" ? (
                  <textarea
                     className="form-control ue-modal-form-control"
                     id={option.name}
                     name={option.name}
                     rows={type.row}
                     {...register(option.name)}
                     onChange={debounce(submitAfterDebounce, 500)}
                  ></textarea>
               ) : type?.form === "number" ? (
                  <div className="col-10">
                     <input
                        type={"number"}
                        step={type.step}
                        className="form-control ue-modal-form-control"
                        id={option.name}
                        name={option.name}
                        {...register(option.name)}
                        onChange={debounce(submitAfterDebounce, 500)}
                     />
                  </div>
               ) : null}
            </div>
         </div>
      </>
   );
};

export default ProfileAnnexesFormGroup;
